
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {
        TrainingType,
        TrainingQualificationRecordDetailsModel,
        QualificationRecordsClient
    } from "../../../../../api-client";
    import {Prop} from "vue-property-decorator";
    import Files from "@/components/Files.vue";

    @Component({
        components: {
            Files
        }
    })
    export default class TrainingQualificationRecordDetails extends Vue {

        @Prop()
        details!: TrainingQualificationRecordDetailsModel;

        navigateToEdit() {
            this.$router.push({name: 'trainingRecordAdd', params: {id: this.details.id ?? ""}});
        }

        get trainingType() {
            const trainingType = this.details.trainingType;
            const trainingTypeMap: { [id: string]: string; } = {};
            trainingTypeMap[TrainingType.Contact] = this.$ls.Documents_Qualifications_TrainingType_Contact;
            trainingTypeMap[TrainingType.Online] = this.$ls.Documents_Qualifications_TrainingType_Online;
            trainingTypeMap[TrainingType.Undefined] = "-";
            return trainingTypeMap[trainingType];
        }

        async getDownloadUrl(fileId: string): Promise<string> {
            return (await new QualificationRecordsClient().downloadTrainingRecordFile(this.$route.params.id, fileId)).url;
        }
    }
